import {texture} from "p3";
import common from "../../common";
import GameScene from "../../scenes/GameScene";
import settings from "../../settings";
import {iswebfont, locale, resizeLabelToFitText} from "../../utils";

export default class IdleMessage extends PIXI.Container {
    /**
     * @param {string} message
     */
    constructor(message, onComplete, currentScene, icon) {
        super();

        this._message = message;
        this._onComplete = onComplete;
        this._icon = icon;
        this._holder = null;
        this._banner = null;
        this._margin = 40;
        this._currentScene = currentScene;
        this._tweens = [];

        this.init();
    }

    init() {

        this._holder = new PIXI.Container();
        this.addChild(this._holder);

        this._banner = new PIXI.NineSlicePlane(texture('dialogue_name_panel_9slice'), 14, 14, 14, 30);
        this._banner.width = 350;
        this._holder.addChild(this._banner);

        if (!iswebfont()) {
            this._label = new PIXI.BitmapText(this._message, {
                fontName: "Alghera Pro",
                fontSize: settings.APP ? 28 : 20,
                align: "center",
                tint: 0x000000,
                maxWidth: this._banner.width - this._banner.leftWidth - this._banner.rightWidth
            });
        } else {
            this._label = new PIXI.Text(this._message, {
                fontFamily: "FredFredBurger",
                fontSize: settings.APP ? 28 : 20,
                align: "center",
                fill: 0x0,
                wordWrap: true,
                wordWrapWidth: this._banner.width - this._banner.leftWidth - this._banner.rightWidth
            });
        }

        this._label.anchor.set(0.5, 0);
        this._label.x = this._banner.width / 2;
        this._label.y = this._banner.topHeight;
        this._holder.addChild(this._label);

        this._banner.height = this._label.height + (this._banner.topHeight * 2);

        if (this._icon) {
            this._banner.width += this._icon.width + 10;
            this._icon.x = this._banner.width - this._banner.rightWidth - this._icon.width;
            this._icon.y = this._banner.topHeight;
            this._holder.addChild(this._icon);
            this._banner.height = Math.max(this._label.height, this._icon.height) + (this._banner.topHeight * 2);
        }

        this.animateIn();
        this.animateOut();
    }

    destroy() {
        for(let i in this._tweens) {
            this._tweens[i].kill();
        }
    }

    animateIn() {
        this._holder.x = -this._label.width - this._margin;
        const tween = gsap.to(this._holder, 1, {x:this._margin, ease:Expo.easeOut});
        if (this._currentScene) {
            this._currentScene.addTween(tween);
        } else {
            this._tweens.push(tween);
        }
    }

    animateOut() {
        const tween = gsap.to(this, 1, {delay:7, x:-this._label.width - this._margin, ease:Expo.easeIn, onComplete:() => {
            this.parent.removeChild(this);
            if(this._onComplete)
                this._onComplete();
        }});
        if (this._currentScene) {
            this._currentScene.addTween(tween);
        } else {
            this._tweens.push(tween);
        }
    }
}


